import { File, FileImage, FileSpreadsheet, FolderArchive } from "lucide-react";
// import { FileTypes } from "../types";
import { AllowedFileTypesEnum, UploadedFile } from "@/api/lctApISchemas";

export const FILE_TYPE_MAP: Record<AllowedFileTypesEnum, { accept: string[]; label: string }> = {
  pdf: {
    accept: ["application/pdf"],
    label: "PDF Documents",
  },
  doc: {
    accept: ["application/msword"],
    label: "Word Documents",
  },
  docx: {
    accept: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
    label: "Word Documents",
  },
  csv: {
    accept: ["text/csv", "application/csv"],
    label: "CSV Files",
  },
  xlsx: {
    accept: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
    label: "Excel Spreadsheets",
  },
  jpeg: {
    accept: ["image/jpeg"],
    label: "JPEG Images",
  },
  jpg: {
    accept: ["image/jpeg"],
    label: "JPG Images",
  },
  png: {
    accept: ["image/png"],
    label: "PNG Images",
  },
  txt: {
    accept: ["text/plain"],
    label: "Text Files",
  },
};

export const getFileIcon = (file: UploadedFile) => {
  if (file.uploaded_file.match(/\.(jpg|jpeg|png)$/i)) {
    return {
      icon: <FileImage className="h-4 w-4 items-center justify-center align-middle" color="gray" />,
    };
  }

  if (file.uploaded_file.includes(".pdf")) {
    return {
      icon: <File className="h-4 w-4 items-center justify-center align-middle" color="gray" />,
    };
  }

  if (file.uploaded_file.includes(".csv")) {
    return {
      icon: <FileSpreadsheet className="h-4 w-4 items-center justify-center align-middle" color="gray" />,
    };
  }

  if (file.uploaded_file.match(/\.(doc|docx|xlsx)$/i)) {
    return {
      icon: <FolderArchive className="h-4 w-4 items-center justify-center align-middle" color="gray" />,
    };
  }

  return {
    icon: <File className="h-4 w-4 items-center justify-center align-middle" color="gray" />,
  };
};

export const getFileName = (file: UploadedFile) => {
  return file.uploaded_file.split("/").pop() || "file";
};

export const getAcceptedMimeTypes = (fileTypes: AllowedFileTypesEnum[]) => {
  return fileTypes.reduce((acc, type) => {
    const mimeTypes = FILE_TYPE_MAP[type];
    return {
      ...acc,
      ...mimeTypes.accept.reduce(
        (mimeAcc, mime) => ({
          ...mimeAcc,
          [mime]: [],
        }),
        {},
      ),
    };
  }, {});
};
